<docs>
# Table

> NOTE: this docs defined at **docs** section inside Table.vue module

Table UI Set

### Example

>Custom Headers(ordering event binding)

```js
export default {
  template: `
  <div>
    <mt-table 
      :tableData="finalData"
      :fixHeaderObjs="fixHeaderObjs"
      :columnHeadersObjs="columnHeadersObjs" 
      :renderHeader="renderHeader"
      class="mt-table--rounded" 
    />
  </div>
  `,
  data(){
    return {
      tableData: [{"ad_account_id":1231619,"ad_account_name":"","amount_spent":34045,"clicks":105,"cpc":324.23809523809524,"ctr":0.0001,"ctype":"NV","end_date":"2018-07-10","impressions":916313,"start_date":"2018-07-03"},{"ad_account_id":102861607002980,"ad_account_name":"Newsjelly","amount_spent":111055,"clicks":351,"cpc":316.396011,"ctr":1.164411,"ctype":"FB","end_date":"2018-07-10","impressions":30144,"start_date":"2018-07-03"},{"ad_account_id":102861607002980,"ad_account_name":"Newsjelly","amount_spent":328,"clicks":1,"cpc":328,"ctr":2.272727,"ctype":"IN","end_date":"2018-07-10","impressions":44,"start_date":"2018-07-03"},{"ad_account_id":6403364258,"ad_account_name":"Newsjelly","advertising_channel_type":"SEARCH","amount_spent":0,"clicks":0,"cpc":null,"ctr":0,"ctype":"GS","end_date":"2018-07-10","impressions":1,"start_date":"2018-07-03"},{"ad_account_id":6403364258,"ad_account_name":"Newsjelly","advertising_channel_type":"DISPLAY","amount_spent":227,"clicks":2,"cpc":113.5,"ctr":0.002,"ctype":"GD","end_date":"2018-07-10","impressions":1025,"start_date":"2018-07-03"},{"ctype":"GY","impressions":0,"clicks":0,"ctr":0,"cpc":0,"amount_spent":0}], fixHeaderObjs: [{"ctype":"채널"}], 
      fixHeaderArray: ['ctype'], 
      columnHeadersObjs: [{"impressions":"노출수"},{"clicks":"클릭수"},{"ctr":"CTR"},{"cpc":"CPC"},{"amount_spent":"소진비용"}],
      sortedField: null,
      sortedBy: 'asc',
    }
  },
  computed:{
    finalData(){
      return lodash.orderBy(this.tableData, [this.sortedField],[this.sortedBy])
    }
  },
  methods: {
    renderHeader(h, { column }) {
      //set fieldName / order
      let sorted = ''
      if(this.sortedField === column.prop){
        sorted = `(sorted-${this.sortedBy}`
      }
      let that = this
      //render
      return h('div', {
        attrs:{class: !!sorted ? 'sorted column': 'column'},
        on: {
          click(e) {
            that.handleClickHeaderColumn(column)
          }
        }
      }, [
        h('p', column.label + sorted),
      ])
    },
    handleClickHeaderColumn(column){
      //set fieldName / order
      if(this.sortedField === column.prop){
        //order toggle
        this.sortedBy = this.sortedBy === 'asc' ? 'desc' : 'asc'
      }
      this.sortedField = column.prop
      console.log(this.sortedField, this.sortedBy)
    },
  },
  
}
```

#### Props

| Property          | Description       | Type     | Accepted Values    | Default     |
|-------------------|-------------------|----------|--------------------|-------------|
| tableData         | data list         | Array    | -                  | required    |
| fixHeaderObjs     | fixed header list | Array    | [{key:value}, ...] | required    |
| columnHeadersObjs | header list       | Array    | [{key:value}, ...] | required    |
| columnFilter      | filter function   | Function | -                  | —           |
| tableOption       | table option      | Object   | -                  | {tableBorder: 0,tableCellspacing: 0} |
| columnOptions     | column option     | Object   | -                  | {width: 120,align: 'right',tooltip: false} |
| renderHeader      | render function   | Function | params: h, {column} |             |


</docs>
<template>
  <div class="mt-table">
    <table class="" :border="tableOption.tableBorder" :cellspacing="tableOption.tableCellspacing">
      <colgroup v-if="computedColumnOptions">
        <col 
          v-for="(header, index) in computedColumnOptions"
          :key="`col-index-${index}`"
          :class="`mt-table_column_${index}`" :width="header['min-width']"
        >
      </colgroup>
      <thead v-if="computedColumnOptions">
        <tr>
          <th 
            v-for="(header, index) in computedColumnOptions"
            :key="`header-${index}`"
            data-selector="header-column"
            class="header"
            >
            <column
              v-if="typeof renderHeader === 'function'"
             :key="`header-${index}`"
             :column="header"
             :renderColumn="renderHeader"
             data-selector="body-column"></column>
            <div v-else class="cell">
              <div class="column">
                <p>{{header.label}}</p>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in tableData" :key="`row-${rowIndex}`">
          <template v-for="(column, colIndex) in headerArray" >
            <td 
              :key="`column-${colIndex}`"
              data-selector="body-column">
              <column
                v-if="typeof renderColumn === 'function'"
                :key="`column-${colIndex}`"
                :column="column"
                :renderColumn="renderColumn"
                data-selector="body-column"></column>
              <div v-else class="cell">{{setRenderColumn(row, column)}}</div>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Column from './Column'

export default {
  name: 'mt-table',
  props: {
    tableData: {
      type: [Array, Object],
      required: true
    },
    fixHeaderObjs: {
      type: Array,
      required: true
    },
    columnHeadersObjs: {
      type: Array,
      required: true
    },
    columnFilter: {
      type: Function,
      required: false
    },
    tableOption: {
      type: Object,
      default: function () {
        return {
          tableBorder: 0,
          tableCellspacing: 0,
        }
      }
    },
    columnOptions: {
      type: Object,
      default: function () {
        return {
          width: 120,
          align: 'right',
          tooltip: false
        }
      }
    },
    renderColumn: {
      type: Function,
    },
    renderHeader: {
      type: Function
    }
  },
  components: {
    Column
  },
  data() {
    return {
      
    }
  },
  computed: {
    fixHeaderArray(){
      let headers = []
      headers = this.fixHeaderObjs.map(header => Object.keys(header)[0])
      return Array.isArray(headers) ? headers : []
    },
    headerArray(){
      let headers = []
      headers = this.columnHeadersObjs.map(header => Object.keys(header)[0])
      return [...this.fixHeaderArray, ...headers]
    },
    computedColumnOptions() {
      //fixed headers를 분리하여 순서보장.
      let headers = [...this.fixHeaderObjs, ...this.columnHeadersObjs]
      let options = []

      headers.map(header => {
        let prop = Object.keys(header)[0]
        let label = Object.values(header)[0]
        let isFixHeader = this.fixHeaderArray.includes(prop)
        let width = isFixHeader ? 283.7 : this.columnOptions.width
        let align = isFixHeader ? 'left' : this.columnOptions.align
        let className = isFixHeader ? 'fix-header' : ''
        const curColumnOptions = {
          label: label,
          prop: prop,
          align,
          'min-width': width,
          'class-name': className
        }
        options.push(curColumnOptions)
      })
      return options
    },
  },

  methods: {
    setRenderColumn(row, column){
      let value = row[column]
      if(typeof this.columnFilter === 'function') value = this.columnFilter(column, value)
      return value
    },
  }
}
</script>
<style lang=''>

</style>



// WEBPACK FOOTER //
// Table.vue?a560f216